import React from 'react'
import { connect } from 'react-redux';
import { dispatch } from 'rxjs/internal/observable/pairs';
import { dataType } from '@/constants/data-type';
import DataTable from '@/components/DataTable/DataTable';
import { userActions } from '@/actions/user';
import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY, REFRESH_DATA } from '@/constants/app';
import { utilsFunction, Converter, Comparator } from "@/helpers/functions";
import { PARAMS as requestParams } from '@/constants/params';
import { getPortfolioAction } from '@/actions/trading';
import Market_HK from './Market_HK'
import Market_US from './Market_US'
import Market_CN from './Market_CN';
import MarketFunds from './MarketFunds';
class Watchlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: null,
      portfolio: [{
        id: '1', title: 'portfolio_title', isActive: false
      }],
      isrefresh:""
    }
    if(props.onRef){
      props.onRef(this)
    }
  }

  componentDidMount() {
    const { currentTradingAccount, token , profile , subTab} = this.props
    // if (currentTradingAccount && token) { 
    //   if(profile){
    //     this.getPostion()
    //   }
    // 
  }

//   componentDidUpdate(preProps) {
//     const { userInfo, isNeedRefresh,language ,marketCode ,currentTradingAccount} = this.props;
//     if (userInfo && preProps.userInfo !== userInfo) {
//       if(marketCode === 'position'){
//         this.getPostion()
//       }else{
//         this.WatchlistRef.getWatchLists(marketCode)
//       }
//     }
//     if (language && preProps.language !== language) {
//       if(marketCode === 'position'){
//         this.getPostion()
//       }else{
//         this.WatchlistRef.getWatchLists(marketCode)
//       }
//     }

//     if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
//       if(marketCode === 'position'){
//         this.getPostion()
//       }else{
//         this.WatchlistRef.getWatchLists(marketCode)
//       }
//     }
//     if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount) {
//       this.getPostion()
//     }
//   }

//   toQuotePage = (data) => {
//     let stock = data.symbol
//     let stockID = stock.substring(stock.indexOf(".") + 1).split('').findIndex(i => i !== '0')
//     if (stockID > -1) {
//       stockID = stock.substring(stock.indexOf(".") + 1).substr(stockID)
//     }
//     // if (this.props.marketParams.stockCode !== utilsFunction.instrumentIDZeroPadding(stockID)) {
//       this.props.setStock({ stockCode: utilsFunction.instrumentIDZeroPadding(stockID), marketID: stock.substring(0, stock.indexOf(".")) }, () => {
//         this.props.onClickSymbol()
//       })
//     // }
//   }

  refresh=(subTab,callback)=>{
    if(subTab === 'HK'){
      this.HKRef.getMostActiveStocks()
      this.HKRef.getGainers();
      this.HKRef.getLosers();
      this.HKRef.updateCharts()
    } else if(subTab === 'CN'){
      this.CNRef.getMostActiveStocks_SH()
      this.CNRef.getMostActiveStocks_SZ()
      this.CNRef.getGainers_SH()
      this.CNRef.getGainers_SZ()
      this.CNRef.updateCharts()
    }else if (subTab === 'FUND') {
      this.FundsRef.searchInput()
    }
    typeof callback === 'function' && callback()
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  
  render() {
    const { rowData, columnDefs } = this.state;
    const { language, autoSize , subTab, innRef} = this.props;
    return (
      <div className="watchlist-container" style={{ flexGrow: 1 }}>
          {subTab == 'HK' && <Market_HK innerRef={(e) => (this.HKRef = e)}></Market_HK> }
          {subTab == 'US' && <Market_US innerRef={(e) => (this.USRef = e)}></Market_US>}
          {subTab == 'CN' && <Market_CN innerRef={(e) => (this.CNRef = e)}></Market_CN> }
          {subTab == 'FUND' && <MarketFunds innerRef={(e) => (this.FundsRef = e)}></MarketFunds> }
      </div>
    )
  }

}

Watchlist.defaultProps = {
  isFilter: false,
  autoSize: true,
  subTab : 'HK'
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    marketParams: state.trade.marketParams,
    userInfo: state.user.userInfo,
    isNeedRefresh: state.refresh.marketAction,
    mdsToken: state.trade.mdsToken,
    user: state.auth.user
  }),
  dispatch => ({
    getWatchlist: (p, c) => dispatch(userActions.getWatchlistAction(p, c)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    toggleRefreshMarket: (p) => dispatch({
      type: REFRESH_DATA.MARKET_ACTION,
      value: p
    }),
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
  })
)(Watchlist)
